import { getLocalStorage } from "utils/globalLocalStorage.js";
import { useStore as getStore } from "../../utils/useStore.js";
import ContentFactory, { languages } from "./contentFactory.js";

/*
 * a function that creates an initial state for the app.
 */

const initialState = () => {
  const lang =
    navigator.userAgent === "ReactSnap"
      ? window.location.href.split("/")[3]
      : window.location.href.split("/")[3] ||
        getLocalStorage("lang") ||
        navigator.language?.split("-")[0] ||
        navigator.userLanguage?.split("-")[0] ||
        "en";
  const tempDirection =
    window.location.href.includes("/he/") ||
    window.location.href.includes("/ar/")
      ? "rtl"
      : "ltr";
  const state = {
    currentPage: null,
    pageMetaData: { title: "JUMBOmail" },
    pageText: {},
    lang: Object.keys(languages).includes(lang) ? lang : "en",
    direction: tempDirection,
    constText: {},
    bannersData: [],
    announcement: null,
    recaptchaRequired: false,
    adsBackgorund: {},
    supportText: {
      categories: [],
      questionsList: [],
      question: [],
    },
    basicSettings: {
      isInit: false,
    },

    // dev settings
    DEV_showConstKeys: false,
  };
  return state;
};

const [ContentProvider, useContent, withContent] = getStore(
  ContentFactory,
  initialState,
  "Content"
);

export const contentInitState = initialState();

export { useContent, ContentProvider, withContent };

export default ContentProvider;
